import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import vuetify from './plugins/vuetify'
import { loadFonts } from './plugins/webfontloader'
const app = createApp(App)

import axios from 'axios'
import VueAxios from 'vue-axios'

loadFonts()

app.use(vuetify)
  .use(VueAxios, axios)
  .use(router)
  .mount('#app')
